import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  CREATE,
  GET,
  CLEAR,
  EDIT,
  DELETE,
  FORSUBMIT
} from '@hobs/constants/subcontractor';

export function createSubcontractor(subcontractor) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Subcontractor', { body: subcontractor, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success() {
    return { type: CREATE.SUCCESS };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function getSubcontractor(SubcontractorId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Subcontractors/${SubcontractorId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function clearSubcontractor() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export function editSubcontractor(subcontractor) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Subcontractor/${subcontractor.subcontractorId}`, {
      body: subcontractor,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EDIT.REQUEST };
  }
  function success() {
    return { type: EDIT.SUCCESS };
  }
  function failure(error) {
    return { type: EDIT.FAILURE, error };
  }
}

export function deleteSubcontractor(subcontractorId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Subcontractor/${subcontractorId}`, { method: 'DELETE' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
    function request() {
      return { type: DELETE.REQUEST };
    }
    function success() {
      return { type: DELETE.SUCCESS };
    }
    function failure(error) {
      return { type: DELETE.FAILURE, error };
    }
  };
}

export function getSubcontractorForSubmit() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Subcontractor/ForSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(response) {
    return { type: FORSUBMIT.SUCCESS, response };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}
